import { Link } from 'app/shared/ui';

export const formTranslations = {
  disclaimer: (
    <>
      Unter den Teilnahmeberechtigten verlosen wir einen Shell-Tankgutschein im
      Wert von 200€ im Zeitraum vom 9.9.2020 bis 9.12.2020, 23:59 Uhr (MEZ). Die
      vollständigen Gewinnspielbedingungen findest du hier und Infos zum
      Datenschutz{' '}
      <Link useRouter={false} target="_blank" href="/privacy">
        hier
      </Link>
      .
    </>
  ),
  title: 'Wilkommen auf heycar!',
  formText:
    'Gib einfach deine E-Mail-Adresse an und erhalte  deinen Link zur Teilnahme.',
  userEmailError: 'E-Mail-Adresse wurde bereits registriert.',
  formButton: 'Senden',
};

export const successTranslations = {
  successMessage:
    'Danke für dein Interesse!  Den Link zur Teilnahme findest du in deinem E-Mail-Postfach.',
  closeButton: 'Alles klar',
};
